import React, { useState } from 'react';
import type SwiperCore from 'swiper';
import { Autoplay, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Link } from 'react-router-dom';
import IconMan from '../../images/common/icon_man11.png';
import IconMan2x from '../../images/common/icon_man11@2x.png';
import IconX from '../../images/common/icon_x.png';
import IconX2x from '../../images/common/icon_x@2x.png';
import { Donor } from '../../models/Donor';

type BasicInfoProps = {
  donor: Donor;
}

const BasicInfo = (props: BasicInfoProps) => {
  const donor = props.donor;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [ thumbsSwiper, setThumbsSwiper ] = useState<SwiperCore>();

  const thumbs = [...Array(1)].map((_, i) => {
    return (
      <SwiperSlide key={ i }>
        <div className="thumb">
          { donor.visiblePhotoUrl ? (
            <img
              src={ donor.visiblePhotoUrl }
              alt={ donor.initialName }
            />
          ) : (
            <img
              src={ IconMan }
              srcSet={ `${ IconMan } 1x, ${ IconMan2x } 2x` }
              alt={ donor.initialName }
            />
          ) }
        </div>
      </SwiperSlide>
    )
  });

  return (
    <>
    <div className="share_links">
      <a
        href={ `https://x.com/intent/tweet?url=${ encodeURIComponent(window.location.href) }&text=${ encodeURIComponent(
          `精子ドナー ${ donor.initialName } のプロフィール\n`
          + `${ donor.basicInfo.age > 0 ? donor.basicInfo.age : '-' } 歳 / ${ donor.physicalInfo.bloodType || '-' } 型 / ${ donor.physicalInfo.height || '-' } cm / ${ donor.physicalInfo.weight || '-' } kg\n`
          + `性病検査: ${ donor.std.certified && donor.std.total === 'MINUS' ? '◎' : '-' } / 精子品質: ${ donor.semen.certified ? donor.semen.total : '-' }\n`
          + `${ donor.basicInfo.areasText.length > 4 ? donor.basicInfo.areasText.slice(0, 4).join('/') + ' 他' : donor.basicInfo.areasText.join('/') }`
        ) }` }
        target="_blank"
        rel="noopener noreferrer"
        className="share_link_x"
      >
        <img
          src={ IconX }
          srcSet={ `${ IconX } 1x, ${ IconX2x } 2x` }
          alt="X"
        />
        でシェア
      </a>
    </div>
    <h2 className="main_title"><span>{ donor.initialName } さんのプロフィール情報 (No. { donor.userNo })</span></h2>
    <div className="prof_wrap">
      <div className="swiper">
        <div className="swiper-container slider">
          <Swiper
            modules={[ Autoplay, Thumbs ]}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            spaceBetween={ 20 }
            // autoplay={{ delay: 3000 }}
            loop
            speed={ 500 }
          >
            { thumbs }
          </Swiper>
        </div>
        <div className="swiper-container slider-thumbnail">
          { /*
          <Swiper
            modules={[ Autoplay, Thumbs ]}
            breakpoints={{
              750: {
                slidesPerView: 5,
                spaceBetween:  20
              }
            }}
            spaceBetween={ 10 }
            slidesPerView={ 3 }
            freeMode
            watchSlidesProgress
            onSwiper={ setThumbsSwiper }
            autoplay={{ delay: 3000 }}
            loop={ true }
            speed={ 500 }
          >
            { thumbs }
          </Swiper>
         */ }
        </div>
      </div>
      <dl className="graf_list">
        <dt>本人確認</dt>
        <dd>{ donor.isKycCertified ? '◎（提出済み）' : '×（未提出）' }</dd>
        <dt>お名前</dt>
        <dd>{ donor.initialName }</dd>
        <dt>年齢</dt>
        <dd>
          {
            donor.basicInfo.age > 0
              ? donor.basicInfo.age
              : '-'
          } 歳
        </dd>
        <dt>血液型</dt>
        <dd>
          { donor.physicalInfo.bloodType || '-' } 型
        </dd>
        <dt>身長 / 体重 / 体格</dt>
        <dd>
          { donor.physicalInfo.height || '-' } cm /&nbsp;
          { donor.physicalInfo.weight || '-' } kg /&nbsp;
          { donor.physicalInfo.bodyFigureText || '-' }
        </dd>
        <dt>まぶた / 頭髪</dt>
        <dd>
          { donor.physicalInfo.eyelidText || '-' } /&nbsp;
          { donor.physicalInfo.hairTypeText || '-' }
          ({ donor.physicalInfo.hairColorText || '-' })
        </dd>
        <dt>対応可能エリア</dt>
        <dd>{ donor.basicInfo.areasText.join("・") }</dd>
        <dt>最終学歴</dt>
        <dd>
          { donor.basicInfo.college }&nbsp;
          { donor.basicInfo.major }&nbsp;
          { donor.basicInfo.majorType ? `（${ donor.basicInfo.majorTypeText }）` : '' }
        </dd>
        <dt>婚姻歴 / 子ども</dt>
        <dd>{ donor.basicInfo.marriageText || '-' }&nbsp;&nbsp;
          男{ donor.basicInfo.son }人 / 女{ donor.basicInfo.daughter }人
        </dd>
        <dt>国籍 / 人種</dt>
        <dd>
          { donor.basicInfo.nationalityText || '-' } /&nbsp;
          { donor.basicInfo.raceText || '-' }
        </dd>
        <dt>提供実績</dt>
        <dd>{ donor.count }回</dd>
        <dt>レビュー</dt>
        <dd>
          { donor.reviewSummary == null || donor.reviewSummary.reviewCount === 0 || donor.reviewSummary.isHidden ?
            (<span>----- (0件)</span>)
          : (<>
               <span className="review-stars">{ donor.reviewSummary.stars }</span>
               <span className="review-score">{ donor.reviewSummary.averageScore }</span>
               <span
                 className="review-count-link"
               >
                 <Link to="#review-list">（{ donor.reviewSummary.reviewCount }件）</Link>
               </span>
             </>)
          }
        </dd>
        <dt>最終ログイン</dt>
        <dd>{ donor.lastActivityOn }</dd>
      </dl>
    </div>
    <h2 className="main_title"><span>自己紹介</span></h2>
    <div className="prof_contents">
      <div className="text_list">
        {
          donor.basicInfo.comments.split('\n\n').map((prg, idx_prg) => {
            const text = prg.split('\n').map((stc, idx_stc) => {
              return (
                <React.Fragment key={ idx_stc }>{ stc }<br /></React.Fragment>
              );
            });

            return (
              <p key={ idx_prg }>{ text }</p>
            );
          })
        }
      </div>
    </div>
    </>
  );
}

export default BasicInfo;
